import { cn } from '@creator/ui/utils/ui';
import TopicChip from '@src/basic-components/TopicChip/TopicChip';
import { useStoreState } from '@src/model/hooks';
import type { Flair } from '@src/store/flairs/flairs';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';
import type { FC } from 'react';

export interface FlairsCardProps {
    tokenName: string;
    className?: string;
    onFlairClick: (flairId: string) => void;
    selectedFlair?: Flair['id'];
    isFlairMandatory?: boolean;
    allowDeselect?: boolean;
}

const FlairsCard: FC<FlairsCardProps> = props => {
    const { allowDeselect, isFlairMandatory = false, selectedFlair, tokenName, className } = props;

    const token = useStoreState(state => state.token.getToken(tokenName));

    const flairs = token ? token.activeFlairs : ([] as Flair[]);

    function onFlairClick(flairId: Flair['id']) {
        const { onFlairClick } = props;
        // If isFlairMandatory is true, only allow to deselect the selectedFlair
        if (isFlairMandatory && flairId === selectedFlair) return;
        // If isFlairMandatory is false, allow to deselect the selectedFlair or select a new one
        if (selectedFlair === flairId) return onFlairClick('');

        onFlairClick(flairId);
    }

    function renderFlair(flair: Flair) {
        const { id } = flair;
        const isActive = selectedFlair === id;

        return <TopicChip showCloseIcon={allowDeselect || (isActive && !isFlairMandatory)} isActive={isActive} onClick={() => onFlairClick(id)} key={id} topicId={id} />;
    }

    function renderTokenFlairs() {
        if (!flairs || flairs.length === 0) return null;
        const renderedFlairs = flairs.map(renderFlair);
        return renderedFlairs;
    }

    return <div className={cn('flex flex-wrap gap-3', className)}>{renderTokenFlairs()}</div>;
};

export default memo(FlairsCard, propsEqualityFn);
